import React from 'react';
import { SUFFIX } from './url';
import { message, Select } from 'antd';
import Observer from '../applications/stores/observer';

const Option = Select.Option;

export const Util = {
    /**
     * 判断是否为空
     * @param {需要判断的对象} value 
     */
    isEmpty(value) {
        if (typeof value === "undefined" || value === '' || value == null) {
            return true;
        } else {
            return false;
        }
    },

    /**
    * 生成随机的唯一id
    * @param {要生成字符串的长度} len 
    * @param {表示进制 可传2,10,16} radix 
    */
    uuid(len, radix) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
        var uuid = [], i;
        radix = radix || chars.length;

        if (len) {
            for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
        } else {
            var r;
            uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
            uuid[14] = '4';

            for (i = 0; i < 36; i++) {
                if (!uuid[i]) {
                    r = 0 | Math.random() * 16;
                    uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                }
            }
        }
        return uuid.join('');
    },

    /*
    ** randomWord 产生任意长度随机字母数字组合
    ** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
        生成3-32位随机串：randomWord(true, 3, 32)
        生成43位随机串：randomWord(false, 43)
    */
    randomWord(randomFlag, min, max) {
        var str = "",
            range = min,
            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;
        }
        for (var i = 0; i < range; i++) {
            let pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
        }
        return str;
    },

    /**
    * 字符串加密成 hex 字符串
    * @param {需要加密的字符串} s
    */
    sha1(s) {
        var data = new Uint8Array(this.encodeUTF8(s))
        var i, j, t;
        var l = ((data.length + 8) >>> 6 << 4) + 16,
            s = new Uint8Array(l << 2);
        s.set(new Uint8Array(data.buffer)), s = new Uint32Array(s.buffer);
        for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2);
        s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8);
        s[l - 1] = data.length << 3;
        var w = [],
            f = [
                function () {
                    return m[1] & m[2] | ~m[1] & m[3];
                },
                function () {
                    return m[1] ^ m[2] ^ m[3];
                },
                function () {
                    return m[1] & m[2] | m[1] & m[3] | m[2] & m[3];
                },
                function () {
                    return m[1] ^ m[2] ^ m[3];
                }
            ],
            rol = function (n, c) {
                return n << c | n >>> (32 - c);
            },
            k = [1518500249, 1859775393, -1894007588, -899497514],
            m = [1732584193, -271733879, null, null, -1009589776];
        m[2] = ~m[0], m[3] = ~m[1];
        for (i = 0; i < s.length; i += 16) {
            var o = m.slice(0);
            for (j = 0; j < 80; j++)
                w[j] = j < 16 ? s[i + j] : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1),
                    t = rol(m[0], 5) + f[j / 20 | 0]() + m[4] + w[j] + k[j / 20 | 0] | 0,
                    m[1] = rol(m[1], 30), m.pop(), m.unshift(t);
            for (j = 0; j < 5; j++) m[j] = m[j] + o[j] | 0;
        };
        t = new DataView(new Uint32Array(m).buffer);
        for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2);

        var hex = Array.prototype.map.call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
            return (e < 16 ? "0" : "") + e.toString(16);
        }).join("");

        return hex;
    },

    /**
     * 字符转换
     * @param {需要转换的字符串} s 
     */
    encodeUTF8(s) {
        var i, r = [],
            c, x;
        for (i = 0; i < s.length; i++)
            if ((c = s.charCodeAt(i)) < 0x80) r.push(c);
            else if (c < 0x800) r.push(0xC0 + (c >> 6 & 0x1F), 0x80 + (c & 0x3F));
            else {
                if ((x = c ^ 0xD800) >> 10 == 0) //对四字节UTF-16转换为Unicode
                    c = (x << 10) + (s.charCodeAt(++i) ^ 0xDC00) + 0x10000,
                        r.push(0xF0 + (c >> 18 & 0x7), 0x80 + (c >> 12 & 0x3F));
                else r.push(0xE0 + (c >> 12 & 0xF));
                r.push(0x80 + (c >> 6 & 0x3F), 0x80 + (c & 0x3F));
            };
        return r;
    },

    /**
     * 组装参数
     * @param {需要组装的参数 对象类型} params 
     */
    assemblyParam(params) {
        var keys = [];
        var paramList = [];
        delete params["mkey"];
        for (var key in params) {
            keys.push(key);
        }
        keys = keys.sort(); //排序
        for (var i = 0; i < keys.length; i++) {
            var tempKey = keys[i];
            params[tempKey] = params[tempKey] = typeof(params[tempKey]) !== "undefined" ? params[tempKey] : "";
            paramList.push(tempKey + '=' + params[tempKey]);
        }
        return paramList.join('&') + SUFFIX;
    },

    /**
     * 生成时间戳
     */
    timestamp() {
        return new Date().valueOf();
    },

    /**
     * 校验必填参数
     */
    checkParams(keyList, _this, callBack) {
        for (let key in keyList) {
            if (this.isEmpty(_this[key]) ) {
                message.warning(`${keyList[key]}不能为空！`);
                return true;
            }
            if((_this[key])instanceof Array){
                if(_this[key].length==0){
                    message.warning(`${keyList[key]}不能为空！`);
                    return true;
                }
            }
        }
    },

    /*
    ** randomWord 产生任意长度随机字母数字组合
    ** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
        生成3-32位随机串：randomWord(true, 3, 32)
        生成43位随机串：randomWord(false, 43)
    */
    randomWord(randomFlag, min, max) {
        var str = "",
            range = min,
            arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if (randomFlag) {
            range = Math.round(Math.random() * (max - min)) + min;
        }
        for (var i = 0; i < range; i++) {
            let pos = Math.round(Math.random() * (arr.length - 1));
            str += arr[pos];
        }
        return str;
    },

    /**
     * 校验JSON  str为待检验的参数   tipValue为提示的名称
     */
    checkJson(str,tipValue) {
        if (typeof str == 'string') {
            try {
                var obj=JSON.parse(str);
                if(typeof obj == 'object' && obj ){
                    return true;
                }else{
                    message.warning(`${tipValue}值不是JSON格式`);  
                    return false;
                }
            } catch(e) {
                message.warning(`${tipValue}值不是JSON格式`);
                return false;
            }
        }
    },

    /**
     *  校验邮箱
     */
    checkedEmail(email,tipValue){
        // 校验邮箱  ^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$
        var reg = new RegExp("^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$");
        if(!reg.test(email)){
            message.warning(`${tipValue}格式有误`);  
            return false;
        }
        return true;
    },

    /**
     *  数组匹配删除，返回下标
     */
    deleteArr(a,x){
        let index = a.indexOf(x);
        if (index > -1) {
            a.splice(index, 1);
        }
        return a;
    },

    /** 
     * 时间戳格式化函数 
     * formatTime('1350052653');//得到的结果是2012/10/12 22:37:33
     *  type 1 精确到天 2精确到月
     */
    formatTime(format,type) {  
        var returnArr   = [];  
        var date = new Date(Number(format) * 1000);  
        returnArr.push(date.getFullYear());  
        returnArr.push(this.formatNumber(date.getMonth() + 1));  
        returnArr.push(this.formatNumber(date.getDate()));  
        returnArr.push(this.formatNumber(date.getHours()));  
        returnArr.push(this.formatNumber(date.getMinutes()));  
        returnArr.push(this.formatNumber(date.getSeconds()));  
        if(Number(type==1)){
            format = returnArr[0]+'/'+returnArr[1]+'/'+returnArr[2]
        }else if(Number(type==2)){
            format = returnArr[0]+'/'+returnArr[1]
        }else{
            format = returnArr[0]+'/'+returnArr[1]+'/'+returnArr[2]+' '+returnArr[3]+':'+returnArr[4]+':'+returnArr[5]
        }
        return format;  
    },   
    formatNumber(n) {  
        n = n.toString()  
        return n[1] ? n : '0' + n  
    },

    /**
     * 限制只能输入数字，小数点两位
     */
    checkNumber(value){
        value = value.replace(/[^\d.]/g,"");  //清除“数字”和“.”以外的字符   
        value = value.replace(/\.{2,}/g,"."); //只保留第一个. 清除多余的   
        value = value.replace(".","$#$").replace(/\./g,"").replace("$#$",".");  
        value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');//只能输入两个小数   
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额 
        if(value.indexOf(".")< 0 && value !=""){ 
            value = parseFloat(value);  
        }
        return value 
    },
        
    /**
     *  处理链接获取参数
     */
    handleUrl(url,value){
        if(value) url = url.slice(0,value);
        let arr = url.split('?');
        let obj = {};
        if(arr.length<2) return obj;
        let objArr = arr[1].split('&');
        objArr.map((item,index)=>{
            let itemArr = item.split('=');
            obj[itemArr[0]] = itemArr[1];
        })
        return obj;
    },

    /**
     *  拼接链接和参数
     */
    combineUrl(url,params){
        if(JSON.stringify(params) == '{}' || params == undefined ) return url;
        let value = ''
        for(let i in params){
            value = value + i+'='+params[i]+'&';
        }
        value = value.slice(0,-1);
        return url+'?'+value;
    },

    /**
     * 设置过期时间以秒为单位的cookie
     * 默认cookie过期时间一天
     */
    setCookie( c_name, value, expireseconds ){
        let exdate = new Date();
        exdate.setTime(exdate.getTime() + (expireseconds ? expireseconds : 3600*24) * 1000);
        document.cookie = c_name + "=" + escape(value) + ((expireseconds==null) ? "" : ";expires="+exdate.toGMTString());
    },

}


// WEBPACK FOOTER //
// ./src/common/util.js